import reducer from "./reducer";
export { default as WorksAndTasksSettings } from "./components/index";
export { default as worksAndTasksSettingsReducerName } from "./constants";
export default reducer;
